// extracted by mini-css-extract-plugin
module.exports = {"boxIcon":"IconMenu_boxIcon__RYLVS","boxMenu":"IconMenu_boxMenu__au3iK"};